import { createHOC } from 'vue-hoc';

import LicenseForm from './LicenseForm';
import userManagement from '../../../../lib/common/providers/userManagement';

const EULA_VERSION = '1.0';

const options = {
  name: 'LicenseFormContainer',
  data() {
    return {
      state: {
        loading: false,
        error: null,
      },
    };
  },
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
  },
  listeners: {
    async acceptLicense() {
      const { query } = this.$route;
      const { token, next } = query;

      this.state.error = null;
      this.state.loading = true;
      try {
        await userManagement.post(
          '/auth/accept-license', 
          {
            token,
            version: EULA_VERSION
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (next) {
          // Login path
          this.$router.push({ name: query.next });
        } else {
          // Signup path
          this.$router.replace({ name: 'signup', query: this.$route.query });
        }
      } catch (error) {
        console.error(error);
        this.state.error = {
          ...error,
          message: error.message || error.description,
        };
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const LicenseContainer = createHOC(
  LicenseForm,
  options,
  renderWith
);
export default LicenseContainer;
